import React, { Component } from 'react';

import { connect } from 'react-redux';

import * as Accounts from 'accounts/components';
import AccountFormHandlers from 'accounts/containers/AccountFormHandlers';

import { getVisibleCustomFieldsEmployees } from 'custom_fields_employees/selectors'; //Groups
import { getVisibleGroups } from 'groups/selectors'; //Groups

import { getIsSaving, getIsFetching, getEditing, getIsFetchingConfig } from 'accounts/selectors';
import { getVisibleAccountsParent, getVisibleDepreciations } from 'selectors/lists';
import { getCompany, getSubcompany } from 'auth/selectors';

class AccountsFormContainer extends Component {
  render = () => (
    <AccountFormHandlers
      render={({
        isSubmitted,
        isSaving,
        handleValueChange,
        handleValidation,
        handleSubmit,
        handleRemoveCustomField,
        handleGroupChange, //Groups
        handleCustomFieldChange, //Groups
        handleAddCustomField,
      }) => (
        <Accounts.FormView
          subcompany={this.props.subcompany}
          isSubmitted={isSubmitted}
          isSaving={isSaving}
          isFetching={this.props.isFetching}
          handleValueChange={handleValueChange}
          handleValidation={handleValidation}
          handleSubmit={handleSubmit}
          handleGroupChange={handleGroupChange} //Groups
          handleCustomFieldChange={handleCustomFieldChange} //Groups
          groups={this.props.groups} //Groups
          handleRemoveCustomField={handleRemoveCustomField}
          handleAddCustomField={handleAddCustomField}
          depreciations={this.props.depreciations}
          company={this.props.company}
          accounts={this.props.accounts}
          account={this.props.account}
        />
      )}
    />
  );
}

const mapStateToProps = (state) => ({
  isSaving: getIsSaving(state),
  isFetching: getIsFetching(state),
  isFetchingConfig: getIsFetchingConfig(state),
  account: getEditing(state),
  company: getCompany(state),
  subcompany: getSubcompany(state),
  customfields: getVisibleCustomFieldsEmployees(state), //Groups
  groups: getVisibleGroups(state), //Groups
  accounts: getVisibleAccountsParent(state),
  depreciations: getVisibleDepreciations(state),
});

export default connect(mapStateToProps, null)(AccountsFormContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/accounts/containers/AccountsFormContainer.js